export enum SponsorTypeEnum {
  SPONSOR = 'SPONSOR',
  PRIMARY_SPONSOR = 'PRIMARY_SPONSOR',
  CO_SPONSOR = 'CO_SPONSOR',
  JOINT_SPONSOR = 'JOINT_SPONSOR',
  NONE = ''
}
